import { useState, useEffect } from "react";

export function useStoreOptions(objects) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const storeCodes = objects.reduce((acc, item) => {
      const code = item.store_code.split("ANGELSPIZZA_")[1];
      if (code && !acc.includes(code)) acc.push(code);
      return acc;
    }, []);
    setOptions(storeCodes.map((code) => ({ value: code, label: code })));
  }, [objects]);

  return options;
}
